import withContainer from 'components/Container/withContainer';
import { HeadlineXl } from 'ui/Styled/Styled';
import { Card, CardsGrid } from 'ui/Card';
import { ReactComponent as Coins } from './assets/coins-alt.svg';
import { ReactComponent as GraduationHat } from './assets/graduation-hat.svg';
import { ReactComponent as Clock } from './assets/clock.svg';
import { ReactComponent as ShieldCheck } from './assets/shield-check.svg';

import { ServiceCardsCollection, ServiceCardProps } from 'ui/Card/ServiceCard';
import { DocumentCard } from 'ui/DocumentCard';
import { Form } from 'ui/FormContainer/FormContainer';
import * as S from './About.styled';
import { createUpBalanceLink } from 'api/money/money';
import { useCurrentOrganization } from 'context/User';
import { useCallback } from 'react';

const options: ServiceCardProps[] = [
    {
        no: 1,
        title: 'Повышение квалификации',
        description:
            'Обновление профессиональных знаний в рамках уже освоенной специальности.',
        price: 200
    },
    {
        no: 2,
        title: 'Профессиональное обучение',
        description:
            'приобретение новых навыков для выполнения конкретной трудовой функции.',
        price: 1500
    },
    {
        no: 3,
        title: 'Профессиональная переподготовка',
        description:
            'освоение новой специальности с правом ведения профессиональной деятельности.',
        price: 3000
    }
];

type Data = {
    quantity: number[];
};

const About = () => {
    const organization = useCurrentOrganization();

    const onSubmit = useCallback(
        (data: Data) => {
            if (!organization) {
                throw new Error("No user's organization");
            }

            const summ = options.reduce(
                (prev, cur) => prev + (data.quantity[cur.no] ?? 0) * cur.price,
                0
            );

            createUpBalanceLink(
                organization.balance.id!,
                summ
            )((linkInfo) => {
                location.href = linkInfo.data.confirmUrl!;
            });
        },
        [organization]
    );

    return (
        <Form wrap={false} onSubmit={onSubmit}>
            <S.Wrapper>
                <HeadlineXl>Преимущества</HeadlineXl>
                <CardsGrid>
                    <Card
                        icon={<Coins />}
                        title="Экономия времени и денег"
                        description="Минимизация временных и финансовых затрат при обучении."
                    />
                    <Card
                        icon={<GraduationHat />}
                        title="Признание опыта"
                        description="Учитываем уже приобретённые знания и навыки."
                    />
                    <Card
                        icon={<Clock />}
                        title="Гибкий график"
                        description="Выбирайте удобный формат: без отрыва от работы или прямо на рабочем месте."
                    />
                    <Card
                        icon={<ShieldCheck />}
                        title="Подлинные документы"
                        description="Оригинальные документы защищены от подделок."
                    />
                </CardsGrid>
                <HeadlineXl>Услуги</HeadlineXl>
                <ServiceCardsCollection
                    cards={options}
                    disabled={!organization}
                />
            </S.Wrapper>
            <S.DocumentsWrapper>
                <HeadlineXl>Документы</HeadlineXl>
                <S.DocumentsGrid>
                    <DocumentCard
                        title="Документ 1"
                        url="https://kursoved.pro/api/file/66af715f-5452-4827-b8e3-3023fe7fe314"
                    />
                    <DocumentCard
                        title="Документ 2"
                        url="https://kursoved.pro/api/file/66af715f-5452-4827-b8e3-3023fe7fe314"
                    />
                    <DocumentCard
                        title="Документ 3"
                        url="https://kursoved.pro/api/file/66af715f-5452-4827-b8e3-3023fe7fe314"
                    />
                </S.DocumentsGrid>
            </S.DocumentsWrapper>
        </Form>
    );
};

export default withContainer(About, {
    heading: 'О платформе'
});
